// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"MhOshK","label":"emaQGQ","indicator":"feXsgt","value":"YqOGbc"};